import React from 'react';
import moment from 'moment';
import showdown from 'showdown';
import escapeHtml from 'escape-html';
import { isUndefined } from 'util';

export default class HistoryTab extends React.Component {
    constructor(args) {
        super(args);

		this.markdownConverter = new showdown.Converter();
    }

    groupHistoryEntries(entries) {
        var groups = [];
        var lastGroup = null;
        var lastDate = null;
        var lastMessageType = null;
        var lastUserName = null;
        var lastCreatedAt = null;

        entries.map((entry, ind, arr) => {
            let barrier = moment(entry.createdAt).add(1, 'minutes');
            let entryDate = moment(entry.createdAt).startOf('day');

            if (lastDate === null || !entryDate.isSame(lastDate)) {
                let dateTitle = {
                    date: entryDate
                };
                groups.push(dateTitle);
            }

            if (lastGroup === null
                || lastDate === null || !entryDate.isSame(lastDate) 
                || lastMessageType !== entry.messageType
                || lastUserName !== entry.userName
                || lastCreatedAt === null || barrier.isBefore(lastCreatedAt)) {
                lastGroup = {
                    messages: []
                };
                groups.push(lastGroup);
            }

            lastGroup.messages.push(entry);
            lastDate = entryDate;
            lastMessageType = entry.messageType;
            lastUserName = entry.userName;
            lastCreatedAt = entry.createdAt;
        });

        return groups;
    }

    getMessageTypeClass(messageType) {
        switch (messageType) {
            case 'Created':
                return 'fa fa-file bg-green';
            case 'StatusChanged':
                return 'fa fa-arrow-up bg-yellow';
            case 'FieldChanged':
                return 'fa fa-edit bg-aqua';
            case 'Error':
                return 'fa fa-warning bg-red';
            default:
                return 'fa fa-comment bg-gray';
        }
    }

	getAuthorIconClass(authorRole) {
        switch (authorRole) {
            case 'system':
                return 'fa fa-gears btn-tool';
            case 'carrier':
                return 'fa fa-truck btn-tool';
            default:
                return 'fa fa-user btn-tool';
        }
	}

    render() {
        let groups = this.groupHistoryEntries(this.props.history);

        let listEntries = groups.map((entry, ind, arr) => {
            if (isUndefined(entry.messages)) {
                let dateKey = 'timeline-date-' + moment(entry.date).format('YYYYMMDD');
                let displayDate = moment(entry.date).format('DD.MM.YYYY');
                return (
                    <li className="time-label" key={dateKey}>
                        <span className="bg-blue">{displayDate}</span>
                    </li>
                );
            } else {
                let firstMessage = entry.messages[0];
                let groupKey = 'timeline-group-' + firstMessage.id;
				let authorIconClass = this.getAuthorIconClass(firstMessage.userRole);
                let iconClass = this.getMessageTypeClass(firstMessage.messageType);
                let groupTime = moment(firstMessage.createdAt).format('HH:mm');
                let messages = entry.messages.map((message, mInd, mArr) => {
                    let entryKey = 'timeline-entry-' + message.id;
					let messageEscaped = escapeHtml(message.message);
					let messageHtml = this.markdownConverter.makeHtml(messageEscaped);
                    let messageTime = moment(message.createdAt).format('HH:mm:ss');
                    return (
                        <div key={entryKey} className="timeline-message clearfix">
							<div className="message-html" dangerouslySetInnerHTML={{__html: messageHtml}} />
                            <div className="message-time">
                                <span className="fa fa-clock-o"></span> {messageTime}
                            </div>
                        </div>
                    );
                });
                return (
                    <li key={groupKey}>
                        <i className={iconClass}></i>
                        <div className="timeline-item">
                            <span className="time"><i className="fa fa-clock-o"></i> {groupTime}</span>
                            <h3 className="timeline-header">
								<span className={authorIconClass}></span>
								{firstMessage.userName}
							</h3>
                            <div className="timeline-body">
                                {messages}
                            </div>
                        </div>
                    </li>
                );
            }
        });

        if (listEntries && listEntries.length > 0) {
            listEntries.push(
                <li key="timeline-footer">
                    <i className="fa fa-clock-o bg-gray"></i>
                </li>
            );
        }

        return (
            <ul className="timeline timeline-inverse">
                {listEntries}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/historyTab.jsx